import React from 'react'
import { css } from '@emotion/core'

type Props = {
  masterUsers?: any
}

export const MasterUsersList: React.FC<Props> = ({ masterUsers }) => {
  return (
    <div css={mainListContainerStyle}>
      <ul css={mainListHeaderStyle}>
        <li css={list1Style}>社員番号</li>
        <li css={list3Style}>氏名</li>
        <li css={list3Style}>ふりがな</li>
        <li css={list3Style}>メールアドレス</li>
        <li css={list2Style}>職位</li>
        <li css={list1Style}>等級</li>
        <li css={list1Style}>本部cd</li>
        <li css={list3Style}>本部名称</li>
        <li css={list2Style}>本部通称</li>
        <li css={list1Style}>部・室cd</li>
        <li css={list3Style}>部・室名称</li>
        <li css={list3Style}>部・室通称</li>
      </ul>
      <ul css={mainListContentsStyle}>
        {masterUsers.map((masterUser: any) => (
          <li key={masterUser.user_id}>
            <div css={[listItemStyle, list1Style]}>
              <div css={overflowText}>{masterUser.employee_number}</div>
            </div>
            <div css={[listItemStyle, list3Style]}>
              <div css={overflowText}>{`${masterUser.last_name}　${masterUser.first_name}`}</div>
            </div>
            <div css={[listItemStyle, list3Style]}>
              <div css={overflowText}>{`${masterUser.last_name_kana}　${masterUser.first_name_kana}`}</div>
            </div>
            <div css={[listItemStyle, list3Style]}>
              <div css={overflowText}>{masterUser.email}</div>
            </div>
            <div css={[listItemStyle, list2Style]}>
              <div css={overflowText}>{masterUser.job_title}</div>
            </div>
            <div css={[listItemStyle, list1Style]}>
              <div css={overflowText}>{masterUser.rate}</div>
            </div>
            <div css={[listItemStyle, list1Style]}>
              <div css={overflowText}>{masterUser.headquarter_cd}</div>
            </div>
            <div css={[listItemStyle, list3Style]}>
              <div css={overflowText}>{masterUser.headquarter_name}</div>
            </div>
            <div css={[listItemStyle, list2Style]}>
              <div css={overflowText}>{masterUser.headquarter_alias_name}</div>
            </div>
            <div css={[listItemStyle, list1Style]}>
              <div css={overflowText}>{masterUser.department_cd}</div>
            </div>
            <div css={[listItemStyle, list3Style]}>
              <div css={overflowText}>{masterUser.department_name}</div>
            </div>
            <div css={[listItemStyle, list3Style]}>
              <div css={overflowText}>{masterUser.department_alias_name}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

const mainListContainerStyle = css({
  display: 'grid',
  width: 'calc(100vw - 220px - 68px)',
  overflowY: 'hidden',
  overflowX: 'scroll',
  height: '480px',
  border: '1px solid #DDDDDD',
  boxSizing: 'border-box',
  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
  borderRadius: '10px',
  backgroundColor: '#FFFFFF',
})

const mainListHeaderStyle = css({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '60px',
  backgroundColor: '#E6E6E6',
  padding: '20px 16px',
  // スクロールバーのサイズ = 15px　ヘッダーはスクロールバーを表示しない為、横幅調整
  marginRight: '15px',
  li: {
    marginRight: '20px',
    whiteSpace: 'nowrap',
    fontSize: '13px',
  },
})

const mainListContentsStyle = css({
  width: '100%',
  height: '420px',
  overflowY: 'scroll',
  backgroundColor: '#FFFFFF',
  scrollbarWidth: 'none',
  li: {
    padding: '20px 16px',
    borderBottom: '1px solid #DDDDDD',
    display: 'flex',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#EEEEEE',
    },
  },
})

const listItemStyle = css({
  display: 'flex',
  alignItems: 'center',
  marginRight: '20px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
})

const overflowText = css({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
})

const list1Style = css({
  width: '50px',
})

const list2Style = css({
  width: '100px',
})

const list3Style = css({
  width: '220px',
})
